export type TaxesTabId = "settings" | "invoicesHistory" | "invoices" | "xmlImports";

export interface TaxesTab {
  id: TaxesTabId;
  path: string;
  labelKey: string;
}

export const TAXES_TABS: TaxesTab[] = [
  {
    id: "settings",
    path: "/taxes/settings",
    labelKey: "tabs.settings",
  },
  {
    id: "invoicesHistory",
    path: "/taxes/invoices-history",
    labelKey: "tabs.invoicesHistory",
  },
  {
    id: "invoices",
    path: "/taxes/invoices",
    labelKey: "tabs.invoices",
  },
  {
    id: "xmlImports",
    path: "/taxes/xml-imports",
    labelKey: "tabs.xmlImports",
  },
];

export function getTaxesTabFromPath(pathname: string): TaxesTabId {
  return TAXES_TABS.find((tab) => pathname === tab.path || pathname.startsWith(`${tab.path}/`))?.id ?? "settings";
}
